import { render, staticRenderFns } from "./VincularCobrancaEstoqueItem.vue?vue&type=template&id=574e4e12&"
import script from "./VincularCobrancaEstoqueItem.vue?vue&type=script&lang=js&"
export * from "./VincularCobrancaEstoqueItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports